import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../api/authClientApi';
import { UserPageWrapper } from '../_pageWrappers/UserPageWrapper';

export default function LogoutPage(): JSX.Element{
    return (
        <UserPageWrapper>
            <LogoutPageContent />
        </UserPageWrapper>
    );
}

function LogoutPageContent(): JSX.Element{

    const navigate = useNavigate();

    useEffect(() => {
        const getData = async () => {
			await logout();
            navigate('/login');
        };
        getData();
    }, []);
    
    return null;
}